import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-md text-red-600 mb-2" }, " Once you delete a user's account, it cannot be recovered! ", -1)
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_ModalContainer = _resolveComponent("ModalContainer")!

  return (_openBlock(), _createBlock(_component_ModalContainer, {
    openImmediately: true,
    onClosed: _ctx.modalClosed
  }, {
    modalTitle: _withCtx(() => [
      _createTextVNode("Are you sure that you want to delete this user?")
    ]),
    modalContent: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_LoadingButton, {
        onClick: _ctx.deleteUser,
        disabled: _ctx.loading,
        loading: _ctx.loading,
        class: "bg-red-600"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Delete User")
        ]),
        _: 1
      }, 8, ["onClick", "disabled", "loading"]),
      (_ctx.responseError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.responseError), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClosed"]))
}